import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Typography, Box, Tab, Tabs, Button } from '@mui/material';
import toast from 'react-hot-toast';
import axios from "axios";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import GeneralInformationBox from "../../Utilities/NCProForms/GeneralInformationBox";
import AffectedItems from "../../Utilities/NCProForms/AffectedItems";
import NonConformanceDescription from "../../Utilities/NCProForms/NonConformanceDescription";
import AdditionalInformation from "../../Utilities/NCProForms/AdditionalInformation";
import NDRCEntry from "../../Utilities/NCProForms/NDRCEntry";
import PRCEntry from "../../Utilities/NCProForms/PRCEntry";
import SRCEntry from "../../Utilities/NCProForms/SRCEntry";
import PreventiveActions from "../../Utilities/NCProForms/PreventiveActions";
import Attachments from "../../Utilities/NCProForms/Attachments";
import CorrectiveActionReview from "../../Utilities/NCProForms/CorrectiveActionReview";
import PreventiveActionReview from "../../Utilities/NCProForms/PreventiveActionReview";
import ClosureVerification from "../../Utilities/NCProForms/ClosureVerification";
import { useNavigate } from 'react-router-dom';
import IICA from "../../Utilities/NCProForms/IICA";
import ConfirmationPopup from "../../Utilities/ConfirmationPopup";
import CircularLoader from "../../Common/CircularLoader";
import { actionSchema, initiateSchema, reviewSchema } from "../../../Helpers/schema";
import ProgressStepper from "../../Utilities/ProgressStepper";
import { getProgressStepperStatus } from "../../../Helpers/NCRHelpers";
import dayjs from "dayjs";
import { fetchDashboardData } from "../../../Helpers/dashboardSlice";

const theme = createTheme({
  components: {
    MuiSelect: {
      styleOverrides: {
        select: {
          fontSize: "14px",
          fontWeight: 400,
          color: "rgba(84, 84, 84, 1)",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          "&::placeholder": {
            fontSize: "14px",
            fontWeight: 400,
            color: "rgba(84, 84, 84, 1)",
            opacity: 1,
          },
        },
      },
    },
  },
});

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default function EditDetails({ content }) {

  const NCRFormData = {
    ncr_id: '',
    date_of_issue: '',
    department: "",
    location: "",
    reported_by: "",
    ncr_type: "",
    category: "",
    affected_item_component_no: "",
    affected_item_revision: "",
    affected_item_qty: null,
    affected_item_description: "",
    affected_item_supplier_cust_name: "",
    affected_item_remarks: "",
    what_went_wrong: "",
    how_was_issue_identified: "",
    relevant_measurements_observations_specification: "",
    evidence_attachments: "",
    corrective_action_required: "",
    // severity_or_priority_level: "",
    responsible_team_or_person: "",
    approving_authority: "",
    evidence_attachments_file_name: "",

    escape_point: '',
    implement_interim_containment_action: '',
    ndrc_identification: '',
    corrective_actions_ndrc: "",
    process_root_cause_description: "",
    process_root_cause_identification: "",
    corrective_actions_process_root_cause: "",
    system_root_cause_identification: "",
    corrective_actions_system_root_cause: "",
    preventive_action_plan: null,
    preventive_action_implementation_timeline: null,
    action_attachments: "",
    action_attachments_file_name: "",

    corrective_action_review_completed: '',
    is_corrective_action_review_effective_resolving_issue: '',
    corrective_action_review_feedback: "",
    corrective_action_review_verification_evidence: "",
    corrective_action_review_verification_evidence_filename: "",
    preventive_action_review_implemented: "",
    preventive_action_review_sufficient_prevent_recurrence: "",
    preventive_action_review_feedback: "",
    preventive_action_review_verification_evidence: "",
    preventive_action_review_verification_evidence_filename: "",

    is_ncr_ready_for_closure: '',
    comments_for_closure: "",
  }

  const [formData, setFormData] = useState(NCRFormData);
  const [initialFormData, setInitialFormData] = useState(NCRFormData);
  const [openPopup, setOpenPopup] = useState(false);
  const lookups = useSelector((state) => state.lookup.data);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState();
  const [tabValue, setTabValue] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const selectedFinancialYear = useSelector(state => state.dashboard.selectedFinancialYear);
  const accessToken = localStorage.getItem('NCProAccessToken');

  const departments = lookups?.["Department"] || [];
  const ncrTypes = lookups?.["NCR Type"] || [];
  const location = lookups?.["Location"] || [];
  const category = lookups?.["Non-conformance Category"] || [];
  const severity_or_priority_level = lookups?.["Severity or Priority Level"] || [];
  const responsibleTeam = lookups?.["Responsible Team/Person"] || [];
  const escapePoint = lookups?.["Escape Point"] || [];
  const IICAValue = lookups?.["Implement Interim Containment Action"] || [];
  const ndrcIdentification = lookups?.["NDRC Identification"] || [];
  const RootCauseIdentification = lookups?.["Root Cause Identification"] || [];
  const srcIdentification = lookups?.["SRC Identification"] || [];

  const { userData } = useSelector((state) => state.user);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChange = (updatedData) => {
    setFormData((prev) => ({
      ...prev,
      ...updatedData,
    }));
    const field = Object.keys(updatedData)[0];
    setErrors((prev) => ({
      ...prev,
      [field]: false,
    }));
  };

  const handleDeleteClick = async () => {
    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_BASE_URL}/ncr/update/${content.ncrId}`,
        { status: "Deleted" },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });

      toast.success(`NC - ${content.ncrId} Deleted Successfully`);
      dispatch(fetchDashboardData({
        startDate: selectedFinancialYear.startDate,
        endDate: selectedFinancialYear.endDate
      }));

      navigate('/ncpro/edit');

    } catch (error) {
      console.error('Error deleting ncr:', error);
    }
  }

  const handleSubmitClick = async () => {
    try {
      const { ncr_id, date_of_issue, evidence_attachments_file_name, action_attachments_file_name, corrective_action_review_verification_evidence_filename, preventive_action_review_verification_evidence_filename, ...filteredData } = formData;

      const currentStage = initialFormData.status;
      const initiateFields = [
        "department",
        "reported_by",
        "ncr_type",
        "location",
        "category",
        "affected_item_component_no",
        "affected_item_revision",
        "affected_item_qty",
        "affected_item_description",
        "affected_item_supplier_cust_name",
        "what_went_wrong",
        "how_was_issue_identified",
        // "severity_or_priority_level",
        "responsible_team_or_person",
      ];
      const actionFields = formData.corrective_action_required === "No"
        ? ["implement_interim_containment_action"]
        : [
          "implement_interim_containment_action",
          "escape_point",
          "ndrc_identification",
          "corrective_actions_ndrc",
          "process_root_cause_description",
          "process_root_cause_identification",
          "corrective_actions_process_root_cause",
          "system_root_cause_identification",
          "corrective_actions_system_root_cause",
          "preventive_action_plan",
          "preventive_action_implementation_timeline"
        ];
      const actionOtherFields = [];
      const otherActionFieldsMapping = {
        implement_interim_containment_action: "implement_interim_containment_action_other",
        escape_point: "escape_point_other",
        ndrc_identification: "ndrc_identification_other",
        process_root_cause_identification: "process_root_cause_identification_other",
        system_root_cause_identification: "system_root_cause_identification_other",
      };
      Object.entries(otherActionFieldsMapping).forEach(([key, otherKey]) => {
        if (formData[key] === "Other") {
          actionOtherFields.push(otherKey);
        }
      });
      const reviewFields = [
        "preventive_action_review_feedback",
        "corrective_action_review_feedback",
      ];
      let requiredFields = [...initiateFields];
      if (currentStage === "In Review") {
        requiredFields.push(...actionFields, ...actionOtherFields);
      } else if (currentStage === "In Closure" && formData.corrective_action_required === 'Yes') {
        requiredFields.push(...actionFields, ...actionOtherFields, ...reviewFields);
      }
      const nonEmptyFilledFields = Object.keys(formData).filter((key) => {
        const val = formData[key];
        return typeof val === "string" && val.trim() !== "";
      });
      requiredFields = [...new Set([...requiredFields, ...nonEmptyFilledFields])];
      const missingFields = requiredFields.filter((key) => {
        const value = formData[key];
        return (
          value === null ||
          value === undefined ||
          (typeof value === "string" && value.trim() === "")
        );
      });

      const timelineDate = dayjs(formData.preventive_action_implementation_timeline);
      if (timelineDate.isValid() && (timelineDate.year() < 1900 || timelineDate.year() > 2099)) {
        toast.error("Year must be between 1900 and 2099.");
        return;
      }

      if (missingFields.length > 0) {
        const errorObj = {};
        missingFields.forEach((key) => {
          errorObj[key] = "This field is required";
        });
        toast.error("Please fill in all required fields.");
        setErrors(errorObj);
        return;
      }

      const fullValidationSchema = initiateSchema.merge(actionSchema).merge(reviewSchema);
      await fullValidationSchema.parseAsync(formData);
      const cleanedData = Object.keys(filteredData).reduce((acc, key) => {
        const value = filteredData[key];
        if (value !== initialFormData[key]) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await axios.put(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/ncr/update/${content.ncrId}`,
        cleanedData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      toast.success(response.data.message || `NC ${content.ncrId} Updated Successfully`);
      dispatch(fetchDashboardData({
        startDate: selectedFinancialYear.startDate,
        endDate: selectedFinancialYear.endDate
      }));
      navigate('/ncpro/edit');

    } catch (error) {
      console.error('Error during form submission:', error);
      const errMessage = error?.response?.data?.message || error?.errors?.[0]?.message || "Something went wrong";
      toast.error(errMessage);
    }
  }

  const handleResetClick = () => {
    setFormData(initialFormData);
    setErrors(null);
  }

  const getFromData = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL}/ncr/forms/${content.ncrId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const updatedFormData = {
        ...response.data.ncrForm,
        evidence_attachments_file_name: response.data.ncrForm.evidence_attachments?.originalname || "",
        action_attachments_file_name: response.data.ncrForm.action_attachments?.originalname || "",
        corrective_action_review_verification_evidence_filename: response.data.ncrForm.corrective_action_review_verification_evidence?.originalname || "",
        preventive_action_review_verification_evidence_filename: response.data.ncrForm.preventive_action_review_verification_evidence?.originalname || "",
      };
      setFormData(updatedFormData);
      setInitialFormData(updatedFormData);
    } catch (error) {
      console.error('Error fetching ncr:', error);
    } finally {
      setIsLoading(false);
    }
  }, [accessToken, content.ncrId]);

  useEffect(() => {
    getFromData();
  }, [getFromData]);

  return (
    <>
      {isLoading ? (
        <CircularLoader label="NCRDetails" />
      ) : (
        <ThemeProvider theme={theme}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mt: 14 }}>
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ pr: '4px' }}>
                <img
                  src="/images/leftArrow.png"
                  alt="Icon"
                  style={{ width: 24, height: 24, marginRight: 4, cursor: 'pointer' }}
                  onClick={() => navigate('/ncpro/edit')}
                />
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontFamily: 'Lato',
                    fontSize: '18px',
                    fontWeight: 700,
                  }}
                >
                  {formData.ncr_id} - Edit
                </Typography>
              </Box>
            </Box>
            <Box>
              <ProgressStepper
                status={getProgressStepperStatus(formData.status, formData.corrective_action_required)}
              />
            </Box>
          </Box>
          <Box
            sx={{
              height: '75vh',
              overflow: 'auto',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: '#fff',
              marginTop: '16px',
              '&::-webkit-scrollbar': {
                width: '7px',
                height: '7px',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: 'rgba(211, 211, 211, 1)',
                borderRadius: '5px',
              }
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Box sx={{
                position: 'sticky',
                top: 0,
                backgroundColor: 'rgba(255, 255, 255, 1)',
                zIndex: 10,
                borderBottom: 1,
                borderColor: 'divider',
              }}>
                <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                  <Tab
                    label="General information"
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: tabValue === 0 ? '700' : '400',
                      color: tabValue === 0 ? 'rgba(42, 61, 189, 1) !Important' : 'rgba(0, 0, 0, 1) !Important',
                      lineHeight: '16.8px',
                      textTransform: 'none',
                      py: "20px"
                    }}
                  />
                  <Tab
                    label={formData.corrective_action_required === 'No' ? 'Containment action' : 'Containment action & Root cause'}
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: tabValue === 1 ? '700' : '400',
                      color: tabValue === 1 ? 'rgba(42, 61, 189, 1) !Important' : 'rgba(0, 0, 0, 1) !Important',
                      lineHeight: '16.8px',
                      textTransform: 'none',
                      py: "20px"
                    }}
                  />
                </Tabs>
              </Box>
              <CustomTabPanel value={tabValue} index={0}>
                <GeneralInformationBox content={{ label: "edit", formData: formData, errors: errors, inputDisable: userData.roleCode !== "CLTADM" && formData.status !== "In Action", lookupTypes: { departments, ncrTypes, location, category } }} onChange={handleChange} />
                <AffectedItems content={{ label: "edit", formData: formData, errors: errors, inputDisable: userData.roleCode !== "CLTADM" && formData.status !== "In Action", userData }} onChange={handleChange} />
                <NonConformanceDescription content={{ label: "edit", formData: formData, inputDisable: userData.roleCode !== "CLTADM", errors: errors }} onChange={handleChange} />
                <AdditionalInformation content={{ label: "edit", formData: formData, errors: errors, inputDisable: userData.roleCode !== "CLTADM" && formData.status !== "In Action", lookupTypes: { severity_or_priority_level, responsibleTeam }, userData: userData }} onChange={handleChange} />
              </CustomTabPanel>
              <CustomTabPanel value={tabValue} index={1}>
                <IICA content={{ formData: formData, errors: errors, inputDisable: formData.status === "In Action" || formData.implement_interim_containment_action === null || userData.roleCode !== "CLTADM", lookupTypes: { IICAValue } }} onChange={handleChange} />
                <NDRCEntry content={{ label: "edit", formData: formData, errors: errors, inputDisable: formData.status === "In Action" || formData.escape_point === null || userData.roleCode !== "CLTADM", lookupTypes: { escapePoint, ndrcIdentification } }} onChange={handleChange} />
                <PRCEntry content={{ label: "edit", formData: formData, errors: errors, inputDisable: formData.status === "In Action" || formData.process_root_cause_description === null || userData.roleCode !== "CLTADM", lookupTypes: { RootCauseIdentification } }} onChange={handleChange} />
                <SRCEntry content={{ label: "edit", formData: formData, errors: errors, inputDisable: formData.status === "In Action" || formData.system_root_cause_identification === null || userData.roleCode !== "CLTADM", lookupTypes: { srcIdentification } }} onChange={handleChange} />
                <PreventiveActions content={{ label: "edit", formData: formData, errors: errors, inputDisable: formData.status === "In Action" || formData.preventive_action_plan === null || userData.roleCode !== "CLTADM" }} onChange={handleChange} />
                <Attachments content={{ label: "edit", formData: formData, errors: errors, inputDisable: formData.status === "In Action" || formData.corrective_action_required === 'No' || userData.roleCode !== "CLTADM" }} onChange={handleChange} />
                <CorrectiveActionReview content={{ label: "edit", formData: formData, errors: errors, inputDisable: ["In Action", "In Review"].includes(formData.status) || formData.corrective_action_review_completed === null || userData.roleCode !== "CLTADM" }} onChange={handleChange} />
                <PreventiveActionReview content={{ label: "edit", formData: formData, errors: errors, inputDisable: ["In Action", "In Review"].includes(formData.status) || formData.preventive_action_review_implemented === null || userData.roleCode !== "CLTADM" }} onChange={handleChange} />
                <ClosureVerification content={{ formData: formData, inputDisable: ["In Action", "In Review", "In Closure"].includes(formData.status) || formData.is_ncr_ready_for_closure === null || userData.roleCode !== "CLTADM" }} onChange={handleChange} />
              </CustomTabPanel>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                px: 3, py: 2,
                position: 'sticky',
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 1)',
                zIndex: 10,
                borderRadius: '0px 0px 10px 10px',
                boxShadow: '0px -1px 4px 0px rgba(0, 0, 0, 0.15)'
              }}>
                {userData.roleCode === "CLTADM" &&
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                    <Button
                      variant="outlined"
                      color="neutral"
                      sx={{
                        fontFamily: 'Lato, sans-serif',
                        fontSize: '14px',
                        fontWeight: '400',
                        border: '1px solid rgba(14, 41, 102, 1) !important',
                        textTransform: 'none',
                        borderRadius: '10px',
                        color: 'rgba(14, 41, 102, 1) !important',
                        py: 1
                      }}
                      onClick={() => setOpenPopup(true)}
                    >
                      Delete
                    </Button>
                  </Box>
                }
                <Box sx={{ px: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    color="neutral"
                    // disabled={tabValue === 0}
                    sx={{
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: '400',
                      border: '1px solid rgba(14, 41, 102, 1) !important',
                      textTransform: 'none',
                      borderRadius: '10px',
                      color: 'rgba(14, 41, 102, 1) !important',
                      // opacity: tabValue === 0 ? '70%' : '100%',
                      py: 1,
                      px: 2.5
                    }}
                    onClick={handleResetClick}
                  >
                    Reset
                  </Button>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <Button
                    variant="outlined"
                    color="neutral"
                    // disabled={tabValue === 0}
                    sx={{
                      background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                      textTransform: 'none',
                      fontFamily: 'Lato, sans-serif',
                      fontSize: '14px',
                      fontWeight: '700',
                      color: 'rgba(255, 255, 255, 1) !important',
                      borderRadius: '10px',
                      border: 'none !important',
                      py: 1.2,
                      px: 3,
                      // opacity: tabValue === 0 ? '70%' : '100%',
                    }}
                    onClick={handleSubmitClick}
                  >
                    Save changes
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </ThemeProvider>
      )}
      <ConfirmationPopup
        open={openPopup}
        label="NCDelete"
        ncrId={content?.ncrId}
        setOpen={setOpenPopup}
        onConfirm={handleDeleteClick}
      />
    </>
  );
}
